import { yupResolver } from "@hookform/resolvers/yup";
import { ButtonSet, Form } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";
import BusinessIdeaForm from "../../components/Forms/BusinessIdeaForm";
import BusinessProfileForm from "../../components/Forms/BusinessProfileForm";
import CompetitorDataForm from "../../components/Forms/CompetitorDataForm";
import ExecutiveSummaryForm from "../../components/Forms/ExecutiveSummaryForm";
import Card from "../../components/Card/Card";
import {
  basicApplicationSchema,
  basicBusinessPlanSchema,
} from "../../services/SchemaService";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../http-common";
import { Tabs } from "carbon-components-react";
import { Tab } from "carbon-components-react";
import { Button } from "carbon-components-react";
import { ArrowRight20 } from "@carbon/icons-react";
import { ArrowLeft20 } from "@carbon/icons-react";
import ApplicationFillingInstructions from "../../components/Miscellaneous/ApplicationFillingInstructions";
import BusinessPlanFillingInstructions from "../../components/Miscellaneous/BusinessPlanFillingInstructions";
import EnvironmentalSocialAnalysisForm from "../../components/Forms/EnvironmentalSocialAnalysisForm";
import FinancialPlanForm from "../../components/Forms/FinancialPlanForm";
import EmployeesForm from "../../components/Forms/WorkersForm";
import MarketAnalysisForm from "../../components/Forms/MarketAnalysisForm";
import CapacityAnalysisForm from "../../components/Forms/CapacityAnalysisForm";
import BusinessPlanIdeaForm from "../../components/Forms/BusinessPlanIdeaForm";
import ExistingBusinessProfileForm from "../../components/Forms/ExistingBusinessProfileForm";
import DataSheetForm from "../../components/Forms/DataSheetForm";
import WorkersForm from "../../components/Forms/WorkersForm";

const CreateBusinessPlanPage = () => {
  const [competitor, setCompetitor] = useState(null);
  const [isQualified, setIsQualified] = useState(false);
  const [hasBusinessCurrently, setHasBusinessCurrently] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const { user, isCompetitor } = useAuth();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(basicBusinessPlanSchema),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    try {
      const response = await http.post("/business-plan", data);
      toast.success("Plano de Negócios Registado com sucesso");
      navigate("../plano-de-negocio/" + response.data.uuid);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await http.get(
          `/business-plan/competitor/${user.username}`
        );
        if (result.data) {
          if (!result.data.isQualified) {
            toast.error(
              "Somente candidatos apurados podem registar o plano de negócios"
            );
          } else {
            try {
              const bp = await http.get(
                `/business-plan/nur/NUR${user.username}`
              );
              if (bp.data) {
                navigate(
                  bp.data.currentStatusCode === 1
                    ? "../editar-plano-de-negocio/" + bp.data.uuid
                    : "../plano-de-negocio/" + bp.data.uuid
                );
              }
            } catch (error) {}

            setCompetitor(result.data);
            setIsQualified(result.data.isQualified);
            setValue("nur", result.data.nur);
          }
        }
      } catch (error) {
        toast.error(error.response?.data.message);
      }
    };

    fetchData();
  }, []);

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };
  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  return (
    <Card title="Registar Plano de Negócio">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Tabs
          scrollIntoView={false}
          selected={activeTab}
          type={"container"}
          onSelectionChange={(e) => setActiveTab(e)}
        >
          <Tab href="#" id="tab-0" label="INSTRUÇÕES">
            <BusinessPlanFillingInstructions />
            <div className="tab-navigation">
              <p></p>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-1" label="SECÇÃO 1">
            <DataSheetForm
              register={register}
              control={control}
              errors={errors}
              setHasBusinessCurrently={setHasBusinessCurrently}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          {hasBusinessCurrently !== null && hasBusinessCurrently === "Sim" && (
            <Tab href="#" id="tab-2" label="SECÇÃO 2">
              <ExistingBusinessProfileForm
                register={register}
                errors={errors}
                setHasBusinessCurrently={setHasBusinessCurrently}
                hasBusinessCurrently={hasBusinessCurrently}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button>
                <Button kind="ghost" size="sm" onClick={nextTab}>
                  Próximo <ArrowRight20 />
                </Button>
              </div>
            </Tab>
          )}
          <Tab href="#" id="tab-4" label="SECÇÃO 3">
            <BusinessPlanIdeaForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-4" label="SECÇÃO 4">
            <CapacityAnalysisForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-4" label="SECÇÃO 5">
            <MarketAnalysisForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-4" label="SECÇÃO 6">
            <WorkersForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-4" label="SECÇÃO 7">
            <FinancialPlanForm
              register={register}
              errors={errors}
              getValues={getValues}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-8" label="SECÇÃO 8">
            <EnvironmentalSocialAnalysisForm
              register={register}
              errors={errors}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
            </div>
          </Tab>
        </Tabs>
        {isQualified && (
          <ButtonSet>
            <SubmitButton />
            <CancelButton />
          </ButtonSet>
        )}
      </Form>
    </Card>
  );
};

export default CreateBusinessPlanPage;
